export const RULES = [
  {
    name: 'couples',
    labelKey: 'search.filter.couples',
    tracking: 'ga-search-form-couples',
    cy: 'rules-couples'
  },
  {
    name: 'pets',
    labelKey: 'search.filter.pets',
    tracking: 'ga-search-form-pets',
    cy: 'rules-pets'
  },
  {
    name: 'students',
    labelKey: 'search.filter.students',
    tracking: 'ga-search-form-students',
    cy: 'rules-students'
  }
];
